import { validatePurchaseReceiving } from "../utils/PurchaseReceiving";
import type { Purchase } from "../models/Purchase";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function PurchaseService(warehouseCode?: string) {
  const service = CreateCrudService<Purchase, KeyValue>({
    PaginationInPath: true,
    WarehouseCode: warehouseCode,
    SearchReferences: true,
    Route: "purchase",
    EntityName: "Purchase",
    DeleteAction: "DeleteInventory",
    PartialFields: ["Code", "Code"],
    LoadingMessage: "Loading purchase records...",
    SavingMessage: "Saving purchase...",
    MapPartial: (x) => ({
      Key: String(x.Code ?? ""),
      Value: String(x.Name ?? x.Code ?? ""),
    }),
  });
  return { ...service, Save: async (rows: Purchase[]) => {
    for (const row of rows) {
      const error = validatePurchaseReceiving(row.Items ?? [], row.AddToInventory);
      if (error) throw new Error(error);
    }
    return service.Save(rows);
  }};
}
